import { useEffect, useRef } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { api } from '@/api/client'
import { Alert, AuthLayout } from '@/components/ui'

interface UnsubscribeResult {
  success: boolean
  message: string
  email: string | null
}

/** Διαγραφή από τη λίστα αποστολής, ο σύνδεσμος κάθε email (§10). */
export default function UnsubscribePage() {
  const { t } = useTranslation()
  const { token = '' } = useParams()
  const attempted = useRef(false)

  const unsubscribe = useMutation({
    mutationFn: () =>
      api.post<UnsubscribeResult>(`/public/unsubscribe/${token}`, undefined, { anonymous: true }),
  })

  useEffect(() => {
    // Η ενέργεια εκτελείται μία φορά, ακόμη και στο διπλό mount του StrictMode.
    if (!token || attempted.current) return
    attempted.current = true
    unsubscribe.mutate()
  }, [token, unsubscribe])

  return (
    <AuthLayout title={t('unsubscribe.title')}>
      {unsubscribe.isPending && <p className="text-gray-500">{t('common.loading')}</p>}

      {unsubscribe.data && (
        <div className="flex flex-col gap-3">
          <Alert tone={unsubscribe.data.success ? 'success' : 'error'}>
            {unsubscribe.data.message}
          </Alert>
          {unsubscribe.data.email && (
            <p className="text-sm text-gray-500">
              {t('unsubscribe.email', { email: unsubscribe.data.email })}
            </p>
          )}
          {unsubscribe.data.success && (
            <p className="text-sm text-gray-500">{t('unsubscribe.reverseHint')}</p>
          )}
        </div>
      )}

      {unsubscribe.isError && <Alert>{t('errors.internal_error')}</Alert>}
    </AuthLayout>
  )
}
